<template>
  <b-form-group
    :class="[
      'text-area transition-input',
      disabled && 'disabled',
      error && 'error',
      value && 'filled',
      hasFocus && 'active',
    ]"
    :label="label"
    :label-for="id"
  >
    <div class="position-relative fake-input">
      <b-form-textarea
        class="text6"
        :id="id"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :readonly="readonly"
        :rows="rows"
        :value="value"
        :autofocus="autofocus"
        :formatter="formatter"
        @focus="onFocus"
        @input="onInput"
        @blur="onBlur"
        ref="$input"
      />
      <div class="text4 text-right" v-if="maxLength">
        {{ length }}/{{ maxLength }}
      </div>
    </div>

    <InputError :error="error" />
  </b-form-group>
</template>

<style lang="scss">
.text-area {
  :disabled {
    cursor: not-allowed;
  }

  textarea,
  .fake-input {
    height: auto !important;
  }

  textarea:disabled {
    background-color: inherit;
  }

  &.transition-input label {
    z-index: 1;
  }

  .form-control {
    background-color: transparent;
    border: none;
    outline: none;
    padding: rem(5px) 0;

    &:focus {
      @include setColor(--color-text);
      @include setColor(--color-selection, border-color);
      box-shadow: none;

      legend {
        transform: translateY(rem(6px)) scale(0.8);
      }
    }

    &::placeholder {
      @include setColor(--color-inactive);
    }
  }

  &.error {
    textarea,
    ::placeholder {
      @include setColor(--color-status-error);
    }
  }
}
</style>

<script>
import InputError from "../InputError/InputError";

export default {
  components: {
    InputError,
  },

  data() {
    return {
      hasFocus: false,
    };
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: String,
      default: "3",
    },
    value: {
      type: String,
      default: "",
    },
    maxLength: {
      type: Number,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    length() {
      return (this.value && this.value.length) || 0;
    },
  },
  methods: {
    onFocus() {
      this.hasFocus = true;
      this.$emit("focus");
    },
    onBlur() {
      this.hasFocus = false;
      this.$emit("blur");
    },
    onInput(value) {
      this.$emit("update:value", value);
    },
    formatter(value) {
      return value.substring(0, this.maxLength);
    },
  },

  mounted() {
    // IOS fix for autofused elements mounted after page load
    if (this.autofocus) {
      this.$refs.$input.focus();
    }
  },
};
</script>
